<template>
    <div class="builder-border">
        <p class="builder-border__title">{{ t("common.setup_border_styles") }}</p>
        <BuilderBorderTypes class="mt-20" :type="initialStyles.type" @selectType="updateType" />
        <CustomCollapse :is-open="type === 'custom'">
            <BuilderBorderSettings :customStyles="customStyles" @update="updateCustomStyles" />
        </CustomCollapse>
    </div>
</template>

<script>
import BuilderBorderTypes from "./BuilderBorderTypes.vue"
import BuilderBorderSettings from "./BuilderBorderSettings.vue"
import CustomCollapse from "@components/Collapse/CustomCollapse.vue"
import cloneDeep from "lodash.clonedeep"

// default browser value
const defaultType = {
    border_radius: { top: 0, right: 0, bottom: 0, left: 0 },
    border: { color: "#000", top: 0, right: 0, bottom: 0, left: 0 },
    shadow: { color: "#000", x: 0, y: 0, blur: 0, spread: 0, inset: false },
    type: "default"
}

// standart project border styles
const standartType = {
    border_radius: { top: 6, right: 6, bottom: 6, left: 6 },
    border: { color: "#000", top: 0, right: 0, bottom: 0, left: 0 },
    shadow: { color: "#809EBF26", x: 0, y: 4, blur: 10, spread: 0, inset: false },
    type: "standart"
}

export default {
    name: "BuilderBorder",
    components: {
        BuilderBorderTypes,
        BuilderBorderSettings,
        CustomCollapse
    },
    props: {
        defaultType: {
            type: String,
            default: "default"
        },
        initialStyles: {
            type: Object,
            default: () => ({
                border_radius: { top: 0, right: 0, bottom: 0, left: 0 },
                border: { color: "#000", top: 0, right: 0, bottom: 0, left: 0 },
                shadow: { color: "#000", x: 0, y: 0, blur: 0, spread: 0, inset: false },
                type: "standart"
            })
        }
    },
    data() {
        return {
            type: this.defaultType,
            customStyles: cloneDeep(this.initialStyles)
        }
    },
    methods: {
        updateType(newType) {
            this.type = newType
            this.customStyles.type = newType
            switch (newType) {
                case "default":
                    this.updateStyleByType(defaultType)
                    break
                case "standart":
                    this.updateStyleByType(standartType)
                    break
                default:
                    this.updateStyleByType(this.customStyles)
                    break
            }
        },
        updateStyleByType(newStyle) {
            this.$emit("update", newStyle)
        },
        updateCustomStyles(e) {
            this.$emit("update", this.customStyles)
        }
    }
}
</script>

<style lang="scss" scoped>
.builder-border {
    display: flex;
    flex-direction: column;
    &__title {
        font-size: 14px;
        font-weight: 400;
        line-height: 22.4px;
    }
}
</style>
